module.exports = __webpack_public_path__ + "static/media/not_implemented.e1f0199d.png";